import { useValidateEnterprisePaymentMutation } from 'api/enterprisePlanApi';
import { showToastError, showToastSuccess } from 'components/toastify/ToastNotifications';
import { ValidatePayment } from 'model/enterprise-plan-model';
import React, { useEffect, useState } from 'react'
import { Col, FloatingLabel, Form, Row, Spinner } from 'react-bootstrap';
import { Link, useSearchParams } from 'react-router-dom';
import Logo from '../../assets/images/logo.svg';

type Props = {}

const PaymentTokenConfirmation = (props: Props) => {
    const [loading, setLoading] = useState(false)
    const [searchParams] = useSearchParams();
    const [validatePayment, setValidatePayment] = useState({ provider: '', paymentDetailsId: '' });

    useEffect(() => {
        if (searchParams.get('id')) {
            setValidatePayment({ ...validatePayment, paymentDetailsId: searchParams.get('id') ?? '' })
        }
        else {
            showToastError('Invalid payment link. Please make sure you use the correct payment link sent to your mail')
        }
    }, [searchParams]);

    const [validatePaymentId] = useValidateEnterprisePaymentMutation();

    const handleValidatePayment = async () => {
        try {
            setLoading(true)
            const model: ValidatePayment = {
                paymentDetailsId: validatePayment.paymentDetailsId,
                provider: validatePayment.provider
            }
            const newTab = window.open('', '_blank');
            const response = await validatePaymentId(model).unwrap();
            if (response?.ResponseCode === '200') {
                showToastSuccess(response?.ResponseMessage);
                setValidatePayment({ provider: '', paymentDetailsId: '' });
                // Open the link in a new tab
                // const link = response?.Data?.Link;
                // if (link) {
                //     window.open(link, '_blank');
                // }
                if (response?.Data?.Link && newTab) {
                    // Redirect the opened tab to the link
                    newTab.location.href = response.Data.Link;
                } 
                // else {
                //     // If no link is present, close the tab
                //     newTab.close();
                //     showToastError('No link found in the response.');
                // }
            }
        }
        catch (error) {
            
        }
        finally {
            setLoading(false);
        }
    }


    return (
        <div className='login-section bg-light'>
            <header><Link to='/'><img src={Logo} /></Link></header>
            <div className='row col-md-5 p-5 my-5 mx-auto bg-white'>
                <h5 className='mb-4'>Enterprise Payment Confirmation</h5>
                <Form.Label>Kindly select your preferred payment provider</Form.Label>
                <Form.Group controlId="application">
                    <FloatingLabel controlId="floatingSelect" label='Choose application type' className='float-input mt-0 mb-3'>
                        <Form.Select
                            name="application"
                            value={validatePayment.provider}
                            onChange={(e) => setValidatePayment({ ...validatePayment, provider: e.target.value })}
                            className={`border-0 w-100`}>
                            <option value="">Select an option</option>
                            <option value="Mollie">Mollie</option>
                            <option value="Stripe">Stripe</option>
                            <option value="Others">Others</option>
                        </Form.Select>
                    </FloatingLabel>
                </Form.Group>
                <div className='py-2'><button type='submit' disabled={loading} onClick={() => handleValidatePayment()} className='btn-primary py-2 w-100'>Proceed {loading && <Spinner size='sm' />} </button></div>
            </div>
        </div>
    )
}

export default PaymentTokenConfirmation;
